import { PathType } from '@convergence/types';
import { getError } from '../util';
import { ActionInputProps } from './types';
import { ActionPathInputSelector } from './type-selectors/path-action-input-selector';
import { actionDataFromTreeAndPath } from './util';

export function AnalysisPathAction(props: ActionInputProps<PathType>) {
  const actionData = actionDataFromTreeAndPath(
    props.tree,
    props.propertyPath
  ) ?? {
    type: 'value',
    value: []
  };

  const error = getError(props.errors, props.propertyPath);

  return (
    <div className="py-2 flex justify-between items-center border-b border-black">
      <label>{props.name}</label>
      <ActionPathInputSelector
        valueSchema={props.value}
        actionData={actionData}
        setActionData={(data) => {
          props.onChange(props.propertyPath, data);
        }}
      />
    </div>
  );
}
